// DashboardSolutionCard.js
import React from 'react';
import { Card, CardContent, Typography, Grid2, Box } from '@mui/material';
import { Dashboard, Dvr, Analytics, Assessment, BarChart, Insights } from '@mui/icons-material'; // Added more icons for variety
import { styled } from '@mui/system';

// Custom styled Card component for the animated border
const AnimatedCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#e8f5e9', // Light green for light theme, darker for dark
  // The 'border' property creates the base for the animation
  border: `2px solid ${theme.palette.success.main}`, // Base border color
  position: 'relative',
  overflow: 'hidden',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)', // Subtle lift on hover
  }
}));

const DashboardSolutionCard = () => {
  return (
    <AnimatedCard raised>
      <CardContent sx={{ p: 4 }}> {/* Increased padding for more space */}
        <Dashboard color="success" sx={{ fontSize: 50, mb: 2 }} /> {/* Larger icon */}
        <Typography variant="h5" component="div" gutterBottom sx={{ fontWeight: 600, color: 'text.primary' }}>
          Your Centralized Dashboard
        </Typography>
        <Typography variant="subtilte1" color="text.secondary" sx={{ mb: 3 }}>
          All your educational data, unified in one powerful, intuitive portal.
        </Typography>

        <Grid2 container spacing={3} justifyContent="center" sx={{ mt: 3 }}>
          <Grid2 item size={{xs:6, sm:4, md:4}}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Dvr color="primary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="body1" sx={{ fontWeight: 500 }}>Comprehensive Oversight</Typography>
            </Box>
          </Grid2>
          <Grid2 item size={{xs:6, sm:4, md:4}}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Analytics color="secondary" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="body1" sx={{ fontWeight: 500 }}>Actionable Insights</Typography>
            </Box>
          </Grid2>
          <Grid2 item size={{xs:12, sm:4,md:4}}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Insights color="success" sx={{ fontSize: 40, mb: 1 }} />
              <Typography variant="body1" sx={{ fontWeight: 500 }}>Data-Driven Decisions</Typography>
            </Box>
          </Grid2>
        </Grid2>

        <Typography variant="body2" color="text.disabled" sx={{ mt: 4, fontStyle: 'italic' }}>
          Eliminate manual reporting. Gain real-time clarity. Drive better educational outcomes.
        </Typography>
      </CardContent>
    </AnimatedCard>
  );
};

export default DashboardSolutionCard;